<template>
  <div>
    <div class="wrap" @click.stop="closeHandler"></div>
    <div class="clinic-modal">
      <CloseBoldIcon :onClose="closeHandler" class="close-icon" />
      <div class="clinic-modal__header">
        <span>{{ item.name }}</span>
      </div>
      <div class="clinic-modal__body">
        <div class="card">
          <div class="card__street">
            <LocateIcon class="card__street-icon" />
            <span class="card__street-title">{{ item.address }}</span>
          </div>
          <template v-if="item.subwayStations.length">
            <div
              v-for="station in item.subwayStations"
              :key="station.id"
              class="card__station"
            >
              <div class="card__station-icon">
                <EllipseIcon :style="{ color: station.color }" />
              </div>
              <span class="card__station-title">{{ station.title }}</span>
            </div>
          </template>
        </div>
        <div class="clinic-modal__action">
          <Button :onClick="redirectClinic" text> Подробнее о клинике </Button>
          <Button
            :onClick="
              () => (!item.status ? changeClinic(item) : removeClinic(item))
            "
            >{{ !item.status ? 'Выбрать клинику' : 'Снять выбор' }}</Button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useStore } from '@/store'

import Button from '@/components/button'

import CloseBoldIcon from '@/assets/icons/close-bold.vue'
import LocateIcon from '@/assets/icons/locate'
import EllipseIcon from '@/assets/icons/ellipse'

export default {
  name: 'clinic-modal',
  components: { CloseBoldIcon, LocateIcon, EllipseIcon, Button },
  props: ['item'],
  setup(props, ctx) {
    const store = useStore()

    function closeHandler() {
      ctx.emit('onClose')
    }

    function changeClinic(item) {
      ctx.emit('changeClinic', item)
      ctx.emit('onClose')
    }

    function removeClinic(item) {
      ctx.emit('removeClinic', item)
      ctx.emit('onClose')
    }

    async function redirectClinic() {
      await store.dispatch('clinics/getClinicById', { id: props.item.id })
      const clinic = store.getters['clinics/clinicsSingleData']
      window.open(clinic.aboutUrl, '_blank')
    }

    return {
      closeHandler,
      changeClinic,
      removeClinic,
      redirectClinic
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'style';
</style>
